import React from 'react'

import { SvgProps } from '../../model/types'

const AttachmentIcon: React.FC<SvgProps> = props => {
	return (
		<svg
			width="18"
			height="16"
			viewBox="0 0 18 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.5938 12.6358C15.9769 11.2527 15.9769 9.0102 14.5938 7.62711L9.14324 2.1765C8.81783 1.85106 8.81783 1.32342 9.14324 0.997981C9.46866 0.672548 9.99633 0.672548 10.3217 0.997981L15.7723 6.44861C17.8063 8.48261 17.8063 11.7803 15.7723 13.8143C13.7384 15.8483 10.4407 15.8483 8.40666 13.8143L1.77839 7.18603C0.313452 5.72109 0.313452 3.34595 1.77839 1.88101C3.24334 0.416065 5.61848 0.416065 7.08342 1.88101L13.7108 8.50836C14.6062 9.40386 14.6062 10.8556 13.7108 11.751C12.8154 12.6464 11.3636 12.6464 10.4682 11.751L4.42918 5.71203C4.10374 5.38659 4.10374 4.85896 4.42918 4.53351C4.75462 4.20808 5.28225 4.20808 5.60769 4.53351L11.6467 10.5725C11.8912 10.8171 12.2877 10.8171 12.5323 10.5725C12.7768 10.3279 12.7768 9.93145 12.5323 9.68695L5.90491 3.05951C5.09084 2.24545 3.77097 2.24545 2.9569 3.05951C2.14284 3.87358 2.14284 5.19345 2.9569 6.00752L9.58516 12.6358C10.9682 14.0189 13.2107 14.0189 14.5938 12.6358Z"
				fill="black"
			/>
		</svg>
	)
}

export default AttachmentIcon
